import styled from 'styled-components';

import { Theme } from '../Theme';
import { Container } from '../Container';
import { FlexRow } from '../Row';
import { FlexColumn } from '../Column';

export const Heading = styled(FlexColumn)`
	display: inline;
	padding-top: 0.75rem;
	font-size: 18px;
	font-family: 'Prompt', sans-serif;
	font-weight: 500;
	align-self: left;
	align-items: center;
`;
export const SubHeading = styled(FlexColumn)`
	font-size: 12px;
	padding-top: 0.75rem;
	padding-left: 0.5rem;
`

export const TitleSection = styled(Container)`
	flex-direction: row;
	flex-wrap: wrap;
	align-self: center;
	margin: 1rem 0 0.25rem;
`;

export const TitleRow = styled(FlexRow)`
	width: 100%;
	gap: 0.5rem;
	margin: 0;
	padding: 0 2rem;
	align-self: center;
`;

export const Title = styled(FlexColumn)`
	display: inline;
	font-size: 25px;
	font-family: 'Prompt', sans-serif;
	font-weight: 500;
	align-self: left;
	align-items: center;
`;

export const SubtitleSection = styled(Container)`
	flex-direction: row;
	flex-wrap: wrap;
	align-self: center;
	margin: 0.15rem 0 0.45rem 0;
`;

export const SubtitleRow = styled(FlexRow)`
	width: 100%;
	gap: 0.5rem;
	margin: 0;
	padding: 0 2rem;
	align-self: center;
`;

export const Subtitle = styled(FlexColumn)`
	font-size: 16px;
	font-family: 'Prompt', sans-serif;
	font-weight: 500;
	align-self: left;
`;

export const Bold = styled.span`
	margin: 0 2px;
	font-weight: 700;
	color:rgb(0, 0, 0);
`;

export const Emphasis = styled(Bold)`
	color: ${Theme.orange};
`;

export const Highlight = styled(Bold)`
	color: ${Theme.green};
`;

export const Warning = styled(Bold)`
	color: ${Theme.red};
`;

export const Message = styled.span`
	color: ${Theme.red};
	width: 100%;
	font-size: inherit;
	font-size: 12px;
`;

export const Note = styled.span`
	padding: 0.25rem 0.5rem;
	background: ${Theme.lightRed};
	color: ${Theme.red};
	font-size: 12px;
	border: 1px solid ${Theme.red};
	border-radius: 4px;
`;

export const NoWrapText = styled.span`
	padding: 0.25rem 0;
	font-size: 14px;
	font-weight: 600;
	text-transform: capitalize;
	white-space: nowrap;
`;
